import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
//import Dashboard from './../components/Menu/Dashboard'
import PropTypes from 'prop-types';
import LoadingScreen from '../components/Complements/LoadingScreen';
import { Grid } from '@material-ui/core';
import { isMobile } from 'react-device-detect';

//import Title from './../components/Complements/Title';
import Footer from '../components/Complements/Footer';
import { history } from '../helpers/history';
class HomeContainer extends Component {

    redirectTimeout = null;

    handleOnClick = () => {
        this.props.history.push('/customers')
    }

    renderAllBody = (renderBody, renderInfoBody, renderChart) => {
        return <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {renderBody}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                {(isMobile) ? renderChart : renderInfoBody}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                {(isMobile) ? /* renderInfoBody */<></> : renderChart}
            </Grid>
        </Grid>
    }

    componentDidMount() {
        this.scheduleRedirect();
    }

    scheduleRedirect = () => {
        if (this.redirectTimeout) {
            clearTimeout(this.redirectTimeout);
        }

        this.redirectTimeout = setTimeout(() => {
            this.handleRedirect();
        }, 100);
    };

    handleRedirect = () => {
        const { user } = this.props;

        const dateAfterLogin = (str1) => new Date(str1) <= new Date();
        const compare_date_change_password = dateAfterLogin(user.nextDateChangePassword);

        if (compare_date_change_password) {
            this.props.handleOpenSnack('COOP GAÑANSOL le recomienda cambiar su contraseña cada cierto tiempo por cuestiones de seguridad de su información.', 'info');
        }
        if (user.flagResetSecurityQuestions === 1) {
            history.push('/questions')
        } else {
            if ((user.flagResetPassword === 1) || (compare_date_change_password)) {
                history.push('/password-change')
            } else {

                if (user.flagUsernameChange === 1) {
                    history.push('/username-change')
                } else {
                    history.push('/')
                }
            }
        }
    };

    componentWillUnmount() {
        if (this.redirectTimeout) {
            clearTimeout(this.redirectTimeout);
        }
    }

    render() {
        const { renderBody, renderInfoBody, renderChart, loading } = this.props
        return (
            <div style = {{
                backgroundSize: "100% 100vh",
                width : "100%",
                minWidth : "100%",
                backgroundRepeat : "repeat-y",
                padding: 20
            }}>

                {this.renderAllBody(renderBody, renderInfoBody, renderChart)}
                <LoadingScreen open={!loading} />
                <Footer />
            </div>
        );
    }
}

HomeContainer.propTypes = {
    user: PropTypes.object,
}

export default withRouter(HomeContainer);
